import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    expenses: [],
    summary: {
      totalAmount: 0,
      count: 0
    },
    filters: {
      timeRange: "Total Data",
      expenseCategory: "",
      modeOfPayment: "",
      status: "",
      minAmount: 0,
      maxAmount: Infinity,
      customFromDate: "",
      customToDate: ""
    }
  },
  loading: false,
  error: null,
};

const customeExpenseReportSlice = createSlice({
  name: "customeExpenseReport",
  initialState,
  reducers: {
    expenseReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    expenseReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
    },
    expenseReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetExpenseReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
    updateExpenseReportFilters(state, action) {
      state.data.filters = {
        ...state.data.filters,
        ...action.payload
      };
    }
  },
});

export const {
  expenseReportRequest,
  expenseReportSuccess,
  expenseReportFailure,
  resetExpenseReport,
  updateExpenseReportFilters
} = customeExpenseReportSlice.actions;

export default customeExpenseReportSlice.reducer;